module.exports = __webpack_public_path__ + "img/turn-down.927b672a.svg";